import getEnvironment from "../src/getEnvironment";
import getBuyerAPIDomain from "../src/APICalls/getBuyerAPIDomain";

const getFeatureFlagService = (featureName: string) => {
  let url = getBuyerAPIDomain();
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  return fetch(`${url.href}/feature/${featureName}`, {
    method: "GET",
    headers,
  });
};

export default getFeatureFlagService;
